










































































































































import { Vue, Component } from "vue-property-decorator";
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';
import CartModal from '@/components/CartModal.vue';

interface Banner {
  id: number;
  imgUrl: string;
  alt: string;
}
interface Category {
  id: number;
  icon: any;
  alt: string;
}
interface Product {
  id: number;
  imgUrl: string;
  brand: string;
  name: string;
  price: number;
  originalPrice?: number;
  salePercent?: number;
  wished?: boolean;
}
interface ProductSection {
  id: number;
  title: string;
  products: Product[];
}

interface Timedeal {
  id: number;
  imgUrl: string;
  brand: string;
  name: string;
  price: number;
  originalPrice?: number;
  salePercent?: number;
  wished?: boolean;
}

function getSampleProducts(startId: number): Product[] {
  const brands = [
    "Dyson", "Apple", "Nike", "LG", "Chanel", "Samsung", "Nintendo", "Le Creuset", "Burberry", "Apple", "Balenciaga", "Logitech", "Philips", "Gucci", "Brita", "Hermes", "Dyson", "Xiaomi", "Adidas", "Ecovacs"
  ];
  const names = [
    "에어랩 컴플리트 롱", "워치 SE 2세대 44mm", "에어맥스 270", "코드제로 A9S 무선청소기", "N°5 오 드 빠르펭 100ml", "갤럭시 버즈2 프로", "스위치 OLED", "냄비", "체크 머플러", "에어팟 프로 2세대", "스피드러너", "MX Master 3S", "소닉케어", "GG 마몬트 카드지갑", "정수기", "트윌리 스카프", "V15 무선청소기", "미밴드 7", "울트라부스트", "로봇청소기"
  ];
  const images = [
    "https://cf.bysuco.net/accec9fa9c250533933837c2c1d19e95.jpg?w=600&f=webp",
    "https://cf.bysuco.net/fb3db1f776b96fd2bd74015405501147.jpg?w=600&f=webp",
    "https://zikoo.s3.ap-northeast-2.amazonaws.com/product/202305/266877/6.jpg",
    "https://zikoo.s3.ap-northeast-2.amazonaws.com/product/202209/252822/181972.jpg",
    "https://zikoo.s3.ap-northeast-2.amazonaws.com/product/202505/291390/183691.jpg",
    "https://zikoo.s3.ap-northeast-2.amazonaws.com/ep/product/20200818/0107_01079000386.png",
    "https://zikoo.s3.ap-northeast-2.amazonaws.com/product/202205/245312/202611000204_20220421_14414046_12_202611000204_1.jfif",
    "https://zikoo.s3.ap-northeast-2.amazonaws.com/product/202505/291390/185852.jpg",
    "https://images.unsplash.com/photo-1583344600609-b9f0d7e7c4b0?auto=format&fit=crop&w=400&q=80",
    "https://images.unsplash.com/photo-1586523996766-3b2d1c6c0e8a?auto=format&fit=crop&w=400&q=80",
    "https://images.unsplash.com/photo-1586523996766-3b2d1c6c0e8a?auto=format&fit=crop&w=400&q=80",
    "https://images.unsplash.com/photo-1505740420928-953e1a026bf4?auto=format&fit=crop&w=400&q=80",
    "https://images.unsplash.com/photo-1526170375885-4d8ccd82030f?auto=format&fit=crop&w=400&q=80",
    "https://images.unsplash.com/photo-1546868871-7041f2a55e12?auto=format&fit=crop&w=400&q=80",
    "https://images.unsplash.com/photo-1560769629-975bb32d6a5e?auto=format&fit=crop&w=400&q=80",
    "https://images.unsplash.com/photo-1585303340058-2041261d4a0f?auto=format&fit=crop&w=400&q=80",
    "https://images.unsplash.com/photo-1596700021650-327c5950d88b?auto=format&fit=crop&w=400&q=80",
    "https://images.unsplash.com/photo-1598379435300-8b1b2234f9a0?auto=format&fit=crop&w=400&q=80",
    "https://images.unsplash.com/photo-1583344600609-b9f0d7e7c4b0?auto=format&fit=crop&w=400&q=80",
    "https://images.unsplash.com/photo-1586523996766-3b2d1c6c0e8a?auto=format&fit=crop&w=400&q=80"
  ];
  const prices = [679000, 359000, 129000, 599000, 189000, 199000, 398000, 249000, 320000, 329000, 990000, 129000, 89000, 450000, 99000, 350000, 1190000, 59000, 179000, 499000];
  const salePercents = [15, 10, 20, 5, 30, 25, 12, 8, 18, 22, 17, 13, 9, 14, 11, 7, 16, 19, 21, 6];
  return Array.from({ length: 20 }, (_, i) => {
    const price = prices[i % prices.length];
    const salePercent = salePercents[i % salePercents.length];
    const originalPrice = Math.round(price / (1 - salePercent / 100));
    return {
      id: startId + i,
      imgUrl: images[i % images.length],
      brand: brands[i % brands.length],
      name: names[i % names.length],
      price,
      originalPrice,
      salePercent,
      wished: false
    };
  });
}

// SVG 아이콘 컴포넌트 정의
const DiptyqueIcon = {
  template: '<svg width="48" height="48" viewBox="0 0 48 48" fill="none"><circle cx="24" cy="24" r="22" stroke="#222" stroke-width="3" fill="#fff"/><text x="50%" y="56%" text-anchor="middle" font-size="12" fill="#222" font-family="Arial" dy=".3em">DP</text></svg>'
};
const LeLaboIcon = {
  template: '<svg width="48" height="48" viewBox="0 0 48 48" fill="none"><rect x="4" y="4" width="40" height="40" rx="10" stroke="#222" stroke-width="3" fill="#fff"/><text x="50%" y="56%" text-anchor="middle" font-size="12" fill="#222" font-family="Arial" dy=".3em">LL</text></svg>'
};
const JoMaloneIcon = {
  template: '<svg width="48" height="48" viewBox="0 0 48 48" fill="none"><rect x="8" y="8" width="32" height="32" rx="8" stroke="#222" stroke-width="3" fill="#fff"/><text x="50%" y="56%" text-anchor="middle" font-size="12" fill="#222" font-family="Arial" dy=".3em">JM</text></svg>'
};
const ByredoIcon = {
  template: '<svg width="48" height="48" viewBox="0 0 48 48" fill="none"><ellipse cx="24" cy="24" rx="20" ry="16" stroke="#222" stroke-width="3" fill="#fff"/><text x="50%" y="56%" text-anchor="middle" font-size="12" fill="#222" font-family="Arial" dy=".3em">BY</text></svg>'
};
const GiftIcon = {
  template: '<svg width="48" height="48" viewBox="0 0 48 48" fill="none"><rect x="8" y="16" width="32" height="24" rx="4" fill="#fff" stroke="#222" stroke-width="3"/><rect x="20" y="8" width="8" height="16" rx="4" fill="#fff" stroke="#222" stroke-width="3"/><line x1="24" y1="16" x2="24" y2="40" stroke="#222" stroke-width="3"/><line x1="8" y1="28" x2="40" y2="28" stroke="#222" stroke-width="3"/></svg>'
};
const PerfumeIcon = {
  template: '<svg width="48" height="48" viewBox="0 0 48 48" fill="none"><ellipse cx="24" cy="32" rx="14" ry="10" fill="#fff" stroke="#222" stroke-width="3"/><rect x="18" y="8" width="12" height="10" rx="3" fill="#fff" stroke="#222" stroke-width="3"/></svg>'
};
const CouponIcon = {
  template: '<svg width="48" height="48" viewBox="0 0 48 48" fill="none"><rect x="8" y="16" width="32" height="16" rx="4" fill="#fff" stroke="#222" stroke-width="3"/><circle cx="16" cy="24" r="3" fill="#222"/><circle cx="32" cy="24" r="3" fill="#222"/></svg>'
};
const MemberIcon = {
  template: '<svg width="48" height="48" viewBox="0 0 48 48" fill="none"><circle cx="24" cy="18" r="8" fill="#fff" stroke="#222" stroke-width="3"/><rect x="10" y="30" width="28" height="10" rx="5" fill="#fff" stroke="#222" stroke-width="3"/></svg>'
};
const ExperienceIcon = {
  template: '<svg width="48" height="48" viewBox="0 0 48 48" fill="none"><rect x="8" y="16" width="32" height="24" rx="6" fill="#fff" stroke="#222" stroke-width="3"/><circle cx="24" cy="28" r="6" fill="#fff" stroke="#222" stroke-width="3"/></svg>'
};
const HourglassIcon = {
  template: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none"><g><path d="M6 2h12v2c0 2.21-1.79 4-4 4h-4c-2.21 0-4-1.79-4-4V2z" fill="#fbc02d"/><path d="M6 22h12v-2c0-2.21-1.79-4-4-4h-4c-2.21 0-4 1.79-4 4v2z" fill="#fbc02d"/><path d="M8 6v2c0 1.1.9 2 2 2h4c1.1 0 2-.9 2-2V6" stroke="#e53935" stroke-width="2"/><path d="M8 18v-2c0-1.1.9-2 2-2h4c1.1 0 2 .9 2 2v2" stroke="#e53935" stroke-width="2"/><path d="M12 10v4" stroke="#e53935" stroke-width="2"/></g></svg>`
};
const SparkleIcon = {
  template: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2l3.09 6.31L22 9l-6.31 3.09L12 22l-3.09-6.31L2 15l6.31-3.09L12 2zM20 2l2 2M2 22l2-2M22 22l-2-2M2 2l2 2"/></svg>`
};
const ShoppingCartIcon = {
  template: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-shopping-cart"><circle cx="8" cy="21" r="1"/><circle cx="19" cy="21" r="1"/><path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12"/></svg>`
};

@Component({
  components: {
    Swiper,
    SwiperSlide,
    DiptyqueIcon,
    LeLaboIcon,
    JoMaloneIcon,
    ByredoIcon,
    GiftIcon,
    PerfumeIcon,
    CouponIcon,
    MemberIcon,
    ExperienceIcon,
    HourglassIcon,
    SparkleIcon,
    ShoppingCartIcon,
    CartModal
  }
})
export default class NewMain extends Vue {
  banners: Banner[] = [
    { id: 1, imgUrl: "https://images.unsplash.com/photo-1519125323398-675f0ddb6308?auto=format&fit=crop&w=1200&q=80", alt: "다이슨 에어랩 배너" },
    { id: 2, imgUrl: "https://images.unsplash.com/photo-1512436991641-6745cdb1723f?auto=format&fit=crop&w=1200&q=80", alt: "애플워치 배너" },
    { id: 3, imgUrl: "https://images.unsplash.com/photo-1517336714731-489689fd1ca8?auto=format&fit=crop&w=1200&q=80", alt: "나이키 운동화 배너" }
  ];
  categories: Category[] = [
    { id: 1, icon: DiptyqueIcon, alt: "딥티크" },
    { id: 2, icon: LeLaboIcon, alt: "르라보" },
    { id: 3, icon: JoMaloneIcon, alt: "조말론" },
    { id: 4, icon: ByredoIcon, alt: "바이레도" },
    { id: 5, icon: GiftIcon, alt: "첫구매 혜택" },
    { id: 6, icon: PerfumeIcon, alt: "무료시향" },
    { id: 7, icon: CouponIcon, alt: "쿠폰" },
    { id: 8, icon: MemberIcon, alt: "회원혜택" },
    { id: 9, icon: ExperienceIcon, alt: "체험단" }
  ];
  productSections: ProductSection[] = [
    {
      id: 1,
      title: "오늘의 반짝 특가",
      products: getSampleProducts(1)
    },
    {
      id: 2,
      title: "추천 상품",
      products: getSampleProducts(101)
    },
    {
      id: 3,
      title: "신상품",
      products: getSampleProducts(201)
    },
    {
      id: 4,
      title: "베스트 셀러",
      products: getSampleProducts(301)
    }
  ];

  flowerBanner: Banner = {
    id: 99,
    imgUrl: "https://picsum.photos/1200/120?random=1",
    alt: "중간 고정 배너 이미지"
  };

  timedeals: Timedeal[] = [
    {
      id: 1,
      imgUrl: "https://www.ahc.co.kr/upload/product/prdImg/20240623_oNE_1719153669339.jpg",
      brand: "Dyson",
      name: "슈퍼소닉 드라이기",
      price: 399000,
      originalPrice: 469412,
      salePercent: 15,
      wished: false
    },
    {
      id: 2,
      imgUrl: "https://www.ahc.co.kr/upload/product/prdImg/20240611_Yvd_1718034191588.jpg",
      brand: "Apple",
      name: "에어팟 프로 2세대",
      price: 249000,
      originalPrice: 276667,
      salePercent: 10,
      wished: false
    }
  ];

  mainTimedealTime = 3600; // 1시간
  timedealInterval: any = null;

  isCartModalOpen = false;
  selectedProduct: Product | null = null;

  bannerSwiperOption = {
    slidesPerView: 1,
    loop: true,
    autoplay: { delay: 4000 },
    pagination: { el: '.swiper-pagination', clickable: true },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    }
  };
  productSwiperOption = {
    slidesPerView: 4,
    spaceBetween: 20,
    loop: false,
    pagination: { el: '.swiper-pagination', clickable: true },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },
    breakpoints: {
      1024: {
        slidesPerView: 4,
        spaceBetween: 20
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 10
      },
      480: {
        slidesPerView: 1,
        spaceBetween: 10
      }
    }
  };

  mounted() {
    // 타임세일 타이머 1초마다 감소
    this.timedealInterval = setInterval(() => {
      if (this.mainTimedealTime > 0) this.mainTimedealTime--;
    }, 1000);
  }
  beforeDestroy() {
    if (this.timedealInterval) clearInterval(this.timedealInterval);
  }

  formatTime(sec: number) {
    const h = Math.floor(sec / 3600);
    const m = Math.floor((sec % 3600) / 60);
    const s = sec % 60;
    return [h, m, s].map(v => String(v).padStart(2, '0')).join(':');
  }

  toggleTimedealWish(dealId: number) {
    const deal = this.timedeals.find(d => d.id === dealId);
    if (!deal) return;
    deal.wished = !deal.wished;
  }

  currency(value: number) {
    return value.toLocaleString("ko-KR") + "원";
  }

  toggleWish(sectionId: number, productId: number) {
    const section = this.productSections.find(s => s.id === sectionId);
    if (!section) return;
    const product = section.products.find(p => p.id === productId);
    if (!product) return;
    product.wished = !product.wished;
  }

  addToCart(productId: number) {
    // 장바구니 추가 로직을 구현해야 합니다.
    console.log(`Adding product ${productId} to cart`);

    // 상품 정보 찾기 (timedeal 또는 productSections에서)
    let productToAdd: Product | undefined;
    productToAdd = this.timedeals.find(d => d.id === productId);
    if (!productToAdd) {
      for (const section of this.productSections) {
        productToAdd = section.products.find(p => p.id === productId);
        if (productToAdd) break;
      }
    }

    if (productToAdd) {
      this.selectedProduct = productToAdd;
      this.isCartModalOpen = true; // 팝업 열기
    } else {
      console.warn(`Product with ID ${productId} not found.`);
    }
  }

  closeCartModal() {
    this.isCartModalOpen = false; // 팝업 닫기
    this.selectedProduct = null; // 선택된 상품 정보 초기화
  }
}
